import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { CountryService } from '@core/admin/services/country.service';
import { LanguagesService } from '@core/admin/services/languages.service';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { NoAuthGuard } from '@core/auth/guards/noAuth.guard';
import { LayoutComponent } from '@layout/layout.component';
import { initialDataResolver } from 'app/app.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

  // Legacy redirects — /management/* → /*
  // { path: 'management', redirectTo: 'dashboard' },
  // { path: 'management/:path', redirectTo: ':path' },
  { path: 'my3ms', redirectTo: 'dashboard' },
  { path: 'pos', redirectTo: 'dashboard' },
  { path: 'doctor', redirectTo: 'dashboard' },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      // {
      //   path: 'confirmation-required',
      //   loadChildren: () =>
      //     import(
      //       '@pages/auth/confirmation-required/confirmation-required.routes'
      //     ),
      // },
      {
        path: 'forgot-password',
        loadChildren: () =>
          import('@pages/auth/forgot-password/forgot-password.routes'),
      },
      {
        path: 'reset-password',
        loadChildren: () =>
          import('@pages/auth/reset-password/reset-password.routes'),
      },
      {
        path: 'sign-in',
        loadChildren: () => import('@pages/auth/sign-in/sign-in.routes'),
      },
      // {
      //   path: 'sign-up',
      //   loadChildren: () => import('@pages/auth/sign-up/sign-up.routes'),
      // },
      {
        path: 'activate',
        loadChildren: () => import('@pages/auth/activation/activation.routes'),
      },
    ],
  },

  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty',
    },
    children: [
      {
        path: 'sign-out',
        loadChildren: () => import('@pages/auth/sign-out/sign-out.routes'),
      },
      {
        path: 'access-denied',
        loadChildren: () => import('@pages/access-denied/access-denied.routes'),
      },
      {
        path: 'unlock-session',
        loadChildren: () =>
          import('@pages/auth/unlock-session/unlock-session.routes'),
      },
    ],
  },

  // // Landing routes
  // {
  //   path: '',
  //   component: LayoutComponent,
  //   data: {
  //     layout: 'empty',
  //   },
  //   children: [
  //     {
  //       path: 'home',
  //       loadChildren: () => import('@pages/landing/home/home.routes'),
  //     },
  //   ],
  // },

  // Backoffice — rota principal
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'dense',
    },
    resolve: {
      initialData: initialDataResolver,
      c: () => inject(CountryService).findAll({ take: 1000 }),
      l: () => inject(LanguagesService).findAll({ take: 1000 }),
    },
    children: [
      {
        path: '',
        loadChildren: () => import('@projects/backoffice/backoffice.routes'),
      },
      {
        path: 'management',
        loadChildren: () => import('@projects/admin/admin.routes'),
      },
    ],
  },
];
